import triggerMethod from '../common/trigger-method';

export default {
  triggerMethod
}
